"use client";

import { useEffect, useState } from "react";
import type { HeroCounterProps } from "./HeroCounter";
import { HeroCounter } from "./HeroCounter";

interface HeroCountdownLiveProps extends Omit<
  HeroCounterProps,
  "days" | "hours" | "mins"
> {
  countdownTo: string;
}

const compute = (target: string) => {
  const diffMs = Math.max(0, Date.parse(target) - Date.now());
  const totalMinutes = Math.floor(diffMs / 60_000);
  return {
    days: Math.floor(totalMinutes / (60 * 24)),
    hours: Math.floor(totalMinutes / 60) % 24,
    mins: totalMinutes % 60,
  };
};

export const HeroCountdownLive = ({
  countdownTo,
  ...rest
}: HeroCountdownLiveProps) => {
  const [values, setValues] = useState(() => compute(countdownTo));

  useEffect(() => {
    const id = setInterval(() => setValues(compute(countdownTo)), 10_000);
    return () => clearInterval(id);
  }, [countdownTo]);

  return <HeroCounter {...rest} {...values} />;
};
